module.exports = __webpack_public_path__ + "static/image/font/pc/bmkiranghaerang-5@3x.ver2_0_2.jpg?3721b428";